<template>
  <a class="curriculum_card_a" href="javascript:void(null);" v-if="item != null">
    <div class="curriculum_card_outer">
      <div class="curriculum_card_title">{{itemTitle}}</div>
      <div class="curriculum_card_desc">{{itemDesc}}</div>
    </div>
  </a>

</template>

<script>
export default {
  name: "HomeCurriculumCard",
  props: {
    item: {
      type: Object,
      value: null
    }
  },
  /*
  * "address": "string",
        "agreementUrl": "string",
        "cityId": 0,
        "coaches": "string",
        "contact": "string",
        "createTime": "2021-02-20T06:44:42.483Z",
        "description": "string",
        "endTime": "2021-02-20T06:44:42.483Z",
        "h5Url": "string",
        "id": 0,
        "imageUrl": "string",
        "isDel": 0,
        "regEndTime": "2021-02-20T06:44:42.483Z",
        "regStartTime": "2021-02-20T06:44:42.483Z",
        "startTime": "2021-02-20T06:44:42.483Z",
        "status": 0,
        "title": "string",
        "type": 0
  *
  * */

  data() {
    return {

    }
  },
  computed: {
    itemTitle() {
      return this.item.title;
    },
    itemDesc() {
      return this.item.subtitle;
    },
    itemHref() {
      return 'javascript:void(null);';
      return '/training/detail/' + this.item.id;
    }
  }
}
</script>

<style scoped>

  .curriculum_card_a {
    text-decoration: none;
    display: inline-block;
  }

  .curriculum_card_outer {
    border-radius: 8px;
    background-color: rgb(252, 26, 52);
    border: solid 1px transparent;
    padding-top: 24px;
    padding-bottom: 22px;
    padding-left: 10px;
    padding-right: 10px;
    width: 32.7929vw;
    min-width: 300px;
    max-width: 445px;
    height: 90px;
    text-align: center;
  }

  @media (min-width: 376px) and (max-width: 767px){
    .curriculum_card_outer {
      width: 90vw;
      max-width: 400px;
      min-width: 340px;
    }
    .curriculum_card_a {
      margin: 15px auto;
    }
  }

  @media (min-width: 768px) {
    .curriculum_card_outer {
      width: 47vw;
      max-width: 445px;
      min-width: 400px;
    }
    .curriculum_card_a {
      margin: 15px 30px;
    }
  }

  @media (max-width: 375px) {
    .curriculum_card_outer {
      width: 90vw;
      min-width: 300px;
    }
    .curriculum_card_a {
      margin: 15px auto;
    }
  }

  .curriculum_card_title {
    color: white;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 1.5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .curriculum_card_desc {
    color: white;
    font-size: 1rem;
    margin-top: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomeCurriculumCard.vue